import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { useParams } from 'react-router-dom'
import { getApiVersion, http } from '@vt/apis/lib-ex'
import { cloneDeep } from 'lodash-es'
import blue from '../assets/blue.png'
import orange from '../assets/orange.png'
import red from '../assets/red.png'
import green from '../assets/green.png'
import NullData from './nullData'

const Item = styled.div`
  ${tw`w-1/2 flex items-center justify-center flex-col gap-2 py-6`}
`
const Title = styled.div`
  width: 180px;
  height: 28px;
  background-image: linear-gradient(
    90deg,
    rgba(1, 176, 234, 0) 0%,
    #13509d 52%,
    rgba(1, 176, 234, 0) 100%
  );
  ${tw`flex items-center justify-center`}
`
const CircleItem = styled.div`
  background: ${(props) => `url(${props.bg}) no-repeat`};
  background-size: 100% 100%;
  width: 92px;
  height: 92px;
  font-size: 18px;
  font-weight: bold;
  ${tw`flex items-center justify-center`};
`
const Bottom = styled.div`
  width: 92px;
  height: 26px;
  background-image: ${(props) => props.background};
  border-radius: 22px;
  margin-top: -15px;
  ${tw`flex items-center justify-center font-bold`};
`

const config = [
  {
    bg: blue,
    background: `linear-gradient(180deg, #175F77 0%, #23476F 100%)`,
  },
  {
    bg: red,
    background: `linear-gradient(180deg, #266AB3 0%, #204A78 100%)`,
  },
  {
    bg: green,
    background: `linear-gradient(180deg, #187266 0%, #0B484B 100%)`,
  },
  {
    bg: orange,
    background: `linear-gradient(180deg, #277B94 0%, #277B94 100%)`,
  },
]
const Circle = function ({ data, customDsl }) {
  const { appId } = useParams()
  const [itemData, setItemData] = useState([])

  useEffect(() => {
    let newDsl = data.dsl
    const _dsl = cloneDeep(customDsl)
    if (_dsl) {
      if (Object.keys(data.dsl).length !== 0) {
        _dsl.childQueries.push(data.dsl)
      }
      newDsl = _dsl
    }
    http()
      .post(`${getApiVersion()}/apps/${appId}/${data.fetch}`, { ...newDsl })
      .json()
      .then((res) => {
        setItemData(res)
      })
  }, [customDsl, data])

  return (
    <div className="w-full flex flex-wrap justify-between flex-1">
      {itemData.length === 0 && <NullData />}
      {itemData.length !== 0 &&
        itemData.map((item, i) => {
          if (i < 4) {
            return (
              <Item style={i === 0 ? { width: '100%' } : {}}>
                <div className="flex flex-col">
                  <CircleItem bg={config[i].bg}>{item.percentage}</CircleItem>
                  <Bottom background={config[i].background}>
                    {item.count}
                  </Bottom>
                </div>
                <Title>{item.title}</Title>
              </Item>
            )
          }
          return null
        })}
    </div>
  )
}

export default Circle
